import React, { FC } from 'react'

// Plugins
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles'

// Components
import { PillButton } from '../Button'

// Types
import { AuthFlowSteps } from '../types'
import { WelcomeProps } from './Welcome.types'

// Images
import { Logo } from './Logo'

export const Welcome: FC<WelcomeProps> = ({ title, signUpText, signInText, setAuthState }) => {
  const classes = useStyles()

  return (
    <main className={classes.root} data-testid='Welcome'>
      <Logo className={classes.logo} fill='white' testId='Logo' />
      <section>
        <h1 className={classes.heading} data-testid='Title'>
          Welcome to <br /> {title}
        </h1>
        <aside>
          <PillButton
            testId='ActionButton'
            className={classes.buttonPill}
            textColor='white'
            borderColor='white'
            onClick={() => setAuthState(AuthFlowSteps.SignUp)}
          >
            {signUpText}
          </PillButton>
          <PillButton
            testId='ActionButton'
            className={classes.buttonPill}
            textColor='white'
            borderColor='white'
            onClick={() => setAuthState(AuthFlowSteps.SignIn)}
          >
            {signInText}
          </PillButton>
        </aside>
      </section>
    </main>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100vw',
      height: '100vh',
      paddingLeft: '10%',
      position: 'absolute',
      top: '0',
      left: '0',
      background: 'rgba(0,0,0,0.4)'
    },
    logo: {
      position: 'absolute',
      top: '50px',
      left: 'calc(10% - 34px)',
      width: '150px',
      [theme.breakpoints.down('xs')]: {
        top: '30px'
      }
    },
    heading: {
      fontSize: '4rem',
      marginTop: '0',
      fontFamily: '"nimbus-sans", sans-serif',
      [theme.breakpoints.down('xs')]: {
        fontSize: '2.5rem'
      }
    },
    buttonPill: {
      width: '200px',
      height: '50px',
      padding: '4px',
      fontSize: '0.75rem',
      marginRight: '16px',
      lineHeight: '0.75rem',
      textDecoration: 'none',
      '&:last-child': {
        marginRight: '0'
      },
      [theme.breakpoints.down('xs')]: {
        width: '140px'
      }
    }
  })
)
